import i18n from '../../i18n'

const LOCALE_FORM_DIR = "forms"
const SECTION = "label"
let localeFile = ''

export const initFormLocale = async (form_slug: string) => {
  localeFile = LOCALE_FORM_DIR + "/" + form_slug
  return i18n.loadNamespaces(localeFile)
}

export const translate = (key: string, defVal?: string) => {
  return i18n.t(localeFile + ":" + key, defVal)
}

export const translateLabel = (id: string, defLabel: string) => {

  if (!defLabel) {
    return defLabel
  }
  if (id.startsWith('/platby/') || id.startsWith('/platbyFull/')) {
    return defLabel
  }
  if(defLabel.startsWith('_version_')){
    id = id + defLabel
  }
  if(defLabel.startsWith('labelGlobal')){
    return i18n.t('labelGlobal.' + id, defLabel)
  }

  id = id.split('_____')[0]
  id = id.replace(/lecivePripravky\/.*\/nehrazeny/, 'lecivePripravky/nehrazeny')
  id = id.replace(/lecivePripravky\/.*\/hrazeny/, 'lecivePripravky/hrazeny')
  id = id.replace(/cenaVyrobceStatyEU1\/...\//, 'cenaVyrobceStatyEU1/')
  id = id.replace(/cenaVyrobceStatyEU2\/...\//, 'cenaVyrobceStatyEU2/')

  id = id.replace(/\/\d+\//g, '/')

  return i18n.t(localeFile + ":" + SECTION + "." + id)
}


